<button
  type="button"
  class="btn btn-outline-primary d-flex align-items-center history-log-btn px-2"
  (click)="toggleDrawer($event)"
  ngbTooltip="View the history of advertising actions and updates."
  container="body"
  placement="bottom"
>
  <i class="feather icon-settings mr-1"></i>
  <span>History Logs</span>
</button>

<!-- Custom Side Drawer -->
<div class="history-log-drawer" [class.show]="isOpened">
  <!-- Backdrop / Overlay -->
  <div class="drawer-overlay" (click)="closeDrawer()"></div>

  <!-- Drawer Container -->
  <div class="drawer-container">
    <div class="drawer-header">
      <div class="d-flex align-items-center">
        <i class="feather icon-list mr-2 text-primary"></i>
        <h6 class="mb-0">Product Ads History Logs</h6>
      </div>
      <button type="button" class="close-btn" (click)="closeDrawer()">
        <i class="feather icon-x"></i>
      </button>
    </div>

    <div class="drawer-filters">
      <div class="filter-row">
        <div class="filter-item flex-grow-1">
          <label>Action Type</label>
          <!-- Removed previous kendo-dropdownlist and use kendo-multiselect instead, 
              reason: UI consistency between product-ads history-log and alert history-log 
          -->
          <kendo-multiselect
            [data]="actionTypes"
            textField="text"
            valueField="value"
            [(ngModel)]="selectedActionTypes"
            [tagMapper]="tagMapper"
            (valueChange)="loadLogs()"
            [checkboxes]="true"
            [autoClose]="false"
          >
          </kendo-multiselect>
        </div>

        <div class="filter-item flex-shrink-0">
          <label>Date Range</label>
          <app-date-range-selection
            [value]="range"
            (valueChange)="onDateRangeChange($event)"
          ></app-date-range-selection>
        </div>
      </div>
    </div>

    <div class="drawer-body" #drawerBody>
      <!-- Initial Loading (No data yet) -->
      <div
        *ngIf="isLoading && !logs.length && !isReverting"
        class="text-center py-5"
      >
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <p class="mt-2 text-muted small">Fetching history logs...</p>
      </div>

      <div class="log-list" *ngIf="logs.length > 0 || isReverting">
        <!-- ── Slim Progress Bar for Revert Action (Non-spatial) ── -->
        <div class="revert-progress-container" *ngIf="isReverting">
          <div class="revert-progress-bar"></div>
          <span class="revert-status-text">Processing revert...</span>
        </div>

        <div
          class="log-item"
          *ngFor="let log of logs; trackBy: trackByLogId"
          [class.is-enable]="log.action === 'UNPAUSE'"
          [class.is-pause]="log.action === 'PAUSE'"
          [class.is-revert]="log.triggerType === 'REVERT'"
          (click)="onLogClick(log)"
          style="cursor: pointer"
        >
          <div class="log-dot"></div>
          <div class="log-card">
            <!-- ── Header: author + action badge ── -->
            <div class="card-row header-row">
              <div class="user-info">
                <ng-container *ngIf="log.triggerType === 'AUTO'; else humanTpl">
                  <i class="fas fa-robot"></i>
                  <span>System</span>
                </ng-container>
                <ng-template #humanTpl>
                  <ng-container
                    *ngIf="log.triggerType === 'REVERT'; else manualIcon"
                  >
                    <i class="fas fa-undo text-warning"></i>
                  </ng-container>
                  <ng-template #manualIcon>
                    <i class="feather icon-user"></i>
                  </ng-template>
                  <span>{{ log.author || "Manual" }}</span>
                </ng-template>
              </div>
              <span
                class="action-badge"
                [class.badge-pause]="
                  log.action === 'PAUSE' && log.triggerType !== 'REVERT'
                "
                [class.badge-enable]="
                  log.action === 'UNPAUSE' && log.triggerType !== 'REVERT'
                "
                [class.badge-revert]="log.triggerType === 'REVERT'"
              >
                {{ getActionLabel(log) }}
              </span>
            </div>

            <!-- ── Meta: date + log ID ── -->
            <div class="card-row meta-row">
              <div class="meta-left">
                <i class="far fa-clock"></i>
                <span class="timestamp">{{
                  log.createdAt | date: "M/d/yyyy hh:mm a"
                }}</span>
              </div>
              <span class="log-id">#{{ log._id.slice(-8) }}</span>
            </div>

            <!-- ── Stats: applied / failed / total ── -->
            <div class="card-row stats-row">
              <ng-container *ngIf="log.failedCount > 0; else simpleStat">
                <span class="stat-chip stat-chip-applied">
                  <i class="feather icon-check-circle"></i>
                  {{ log.appliedCount }} applied
                </span>
                <span class="stat-sep">·</span>
                <span class="stat-chip stat-chip-failed">
                  <i class="feather icon-alert-circle"></i>
                  {{ log.failedCount }} failed
                </span>
                <span class="stat-sep">·</span>
                <span class="stat-chip stat-chip-total">
                  <i class="feather icon-package"></i>
                  {{ log.totalCount }} SKU(s)
                </span>
              </ng-container>
              <ng-template #simpleStat>
                <span class="stat-chip stat-chip-total">
                  <i class="feather icon-package"></i>
                  {{ log.totalCount }} SKU(s) affected
                </span>
              </ng-template>
              <span
                class="revert-source"
                *ngIf="log.triggerType === 'REVERT' && log.sourceLogId"
              >
                <i class="fas fa-link"></i>
                from #{{ log.sourceLogId.slice(-8) }}
              </span>
            </div>

            <!-- ── Footer: actions ── -->
            <div class="card-footer">
              <div class="card-footer-actions">
                <button
                  class="btn btn-action-mini"
                  (click)="$event.stopPropagation(); onDownloadSnapshot(log)"
                >
                  <i class="feather icon-download mr-1"></i> Download
                </button>
                <button
                  *ngIf="!isRevertExists(log._id) &&log.triggerType !== 'REVERT'"
                  class="btn btn-action-mini btn-action-revert"
                  (click)="onRevert(log, $event)"
                  title="Revert this action"
                >
                  <i class="fas fa-undo mr-1"></i> Revert
                </button>
                <button
                  *ngIf="isRevertExists(log._id)"
                  class="btn btn-action-mini btn-action-reverted"
                  title="Reverted"
                  disabled
                >
                  <i class="fas fa-check mr-1"></i> Reverted
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- No Logs State -->
      <div
        class="no-logs"
        *ngIf="!isLoading && !isReverting && logs.length === 0"
      >
        <div class="text-center py-5">
          <i
            class="feather icon-inbox text-muted mb-2"
            style="font-size: 2rem"
          ></i>
          <p class="text-muted">
            No history logs found for the selected filters.
          </p>
        </div>
      </div>

      <!-- Pagination -->
      <div
        class="drawer-pagination d-flex justify-content-between align-items-center mt-3 px-2"
        *ngIf="total > pageSize"
      >
        <button
          class="btn btn-sm btn-outline-secondary"
          [disabled]="currentPage === 0"
          (click)="onPrevPage()"
        >
          <i class="feather icon-chevron-left"></i> Prev
        </button>
        <span class="text-muted small"
          >Page {{ currentPage + 1 }} of {{ totalPages }}</span
        >
        <button
          class="btn btn-sm btn-outline-secondary"
          [disabled]="currentPage >= totalPages - 1"
          (click)="onNextPage()"
        >
          Next <i class="feather icon-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Detail Modal -->
<kendo-dialog
  *ngIf="isDetailOpen && selectedLog"
  [title]="'History Log Detail'"
  [width]="'80vw'"
  (close)="closeDetail()"
  cssClass="history-log-detail-dialog"
>
  <!-- Initial Loading Skeleton (Only shown when no data exists yet) -->
  <div
    *ngIf="isDetailLoading && !selectedLogDetail"
    class="history-log-detail-skeleton"
  >
    <!-- Header summary skeleton -->
    <div class="d-flex align-items-center mb-3 flex-wrap" style="gap: 12px">
      <div class="skeleton-shimmer badge-skeleton"></div>
      <div class="skeleton-shimmer text-skeleton" style="width: 120px"></div>
      <div class="skeleton-shimmer text-skeleton" style="width: 100px"></div>
      <div class="skeleton-shimmer text-skeleton" style="width: 240px"></div>
    </div>
  </div>

  <!-- Detail Content (Visible once data is available, even if updating/refreshing) -->
  <ng-container *ngIf="selectedLogDetail">
    <!-- Header summary -->
    <div class="d-flex align-items-center mb-3 flex-wrap" style="gap: 12px">
      <span
        class="badge"
        [class.badge-danger]="selectedLog.action === 'PAUSE'"
        [class.badge-success]="selectedLog.action === 'UNPAUSE'"
      >
        {{ selectedLog.action === "PAUSE" ? "PAUSED" : "ENABLED" }}
      </span>
      <span class="text-muted small">{{
        selectedLog.createdAt | date: "M/d/yyyy hh:mm a"
      }}</span>
      <span class="text-muted small">
        <ng-container *ngIf="selectedLog.triggerType === 'AUTO'">
          <i class="fas fa-robot mr-1"></i> Automated
        </ng-container>
        <ng-container *ngIf="selectedLog.triggerType !== 'AUTO'">
          <i class="feather icon-user mr-1"></i> Manual
          <ng-container *ngIf="selectedLog.author">
            &mdash; {{ selectedLog.author }}</ng-container
          >
        </ng-container>
      </span>
      <span class="text-muted small">
        Total: {{ selectedLog.totalCount }} &nbsp;|&nbsp; Applied:
        {{ selectedLog.appliedCount }} &nbsp;|&nbsp; Failed:
        {{ selectedLog.failedCount }}
      </span>
    </div>
  </ng-container>

  <!-- Search input (always visible, disabled while loading) -->
  <div class="search-container mb-3">
    <div class="search-input-wrapper">
      <i class="feather icon-search search-icon"></i>
      <input
        type="text"
        class="form-control search-input"
        placeholder="Search by SKU, ASIN..."
        [(ngModel)]="detailSearch"
        [disabled]="isDetailLoading"
        (input)="onDetailSearchChange($event.target.value)"
      />
      <button
        *ngIf="detailSearch"
        class="clear-search-btn"
        (click)="clearSearch()"
        [disabled]="isDetailLoading"
        title="Clear search"
      >
        <i class="feather icon-x"></i>
      </button>
    </div>
  </div>

  <!-- Treelist: root = SKU rows, children = campaign/ad-group rows -->
  <app-forecast-rxtreelist
    [idField]="'_id'"
    [columns]="detailColumns"
    [rootItems]="detailRootItems"
    [totalRootCount]="detailTotal"
    [pageSize]="detailPageSize"
    [skip]="detailSkip"
    [levelConfigs]="treeLevelConfigs"
    [height]="'40vh'"
    [loading]="isDetailLoading"
    [fullScreenIconIsVisible]="false"
    [toogleFullScreenIsVisible]="false"
    [showCheckboxColumn]="false"
    (pageChange)="onDetailPageChange($event)"
    (sortFilterChange)="onDetailSortFilterChange($event)"
  >
    <!-- Custom chip cell for Inventory Status -->
    <!-- Severity gradient: WELL_STOCK (green) → MODERATE_RISK (blue) → HIGH_RISK (amber) → OUT_OF_STOCK (red) -->
    <ng-template appTreelistCustomCell="inventoryStatus" let-dataItem>
      <div class="d-flex align-items-center justify-content-center">
        <ng-container [ngSwitch]="dataItem.inventoryStatus">
          <kendo-chip
            *ngSwitchCase="'OUT_OF_STOCK'"
            rounded="full"
            themeColor="error"
            icon="cancel"
            >Out of Stock</kendo-chip
          >
          <kendo-chip
            *ngSwitchCase="'HIGH_RISK'"
            rounded="full"
            themeColor="inverse"
            icon="x-circle"
            >High Risk</kendo-chip
          >
          <kendo-chip
            *ngSwitchCase="'MODERATE_RISK'"
            rounded="full"
            themeColor="warning"
            icon="minus-circle"
            >Moderate Risk</kendo-chip
          >
          <kendo-chip
            *ngSwitchCase="'WELL_STOCK'"
            rounded="full"
            themeColor="success"
            icon="check-circle"
            >Well Stock</kendo-chip
          >
          <span *ngSwitchDefault>{{ dataItem.inventoryStatus }}</span>
        </ng-container>
      </div>
    </ng-template>

    <!-- Custom chip cell for Prev State -->
    <!-- ENABLED = success (green, active); PAUSED = error (red, stopped) -->
    <ng-template appTreelistCustomCell="prevState" let-dataItem>
      <div class="d-flex align-items-center justify-content-center">
        <ng-container *ngIf="dataItem.prevState; else emptyPrev">
          <kendo-chip
            rounded="full"
            [themeColor]="
              dataItem.prevState === 'ENABLED' ? 'success' : 'error'
            "
          >
            {{ dataItem.prevState }}
          </kendo-chip>
        </ng-container>
        <ng-template #emptyPrev><span></span></ng-template>
      </div>
    </ng-template>

    <!-- Custom chip cell for New State -->
    <ng-template appTreelistCustomCell="newState" let-dataItem>
      <div class="d-flex align-items-center justify-content-center">
        <ng-container *ngIf="dataItem.newState; else emptyNew">
          <kendo-chip
            rounded="full"
            [themeColor]="dataItem.newState === 'ENABLED' ? 'success' : 'error'"
          >
            {{ dataItem.newState }}
          </kendo-chip>
        </ng-container>
        <ng-template #emptyNew><span></span></ng-template>
      </div>
    </ng-template>

    <!-- Reason: wrap text so full message is always readable -->
    <ng-template appTreelistCustomCell="reason" let-dataItem>
      <span
        style="white-space: normal; word-break: break-word; display: block"
        >{{ dataItem.reason }}</span
      >
    </ng-template>
  </app-forecast-rxtreelist>

  <kendo-dialog-actions>
    <button
      kendoButton
      (click)="onDownloadSnapshot(selectedLog)"
      [primary]="false"
    >
      <i class="feather icon-download mr-1"></i> Download
    </button>
    <button
      kendoButton
      *ngIf="selectedLog && selectedLog.triggerType !== 'REVERT' && !isRevertExists(selectedLog._id)"
      [primary]="false"
      (click)="onRevert(selectedLog, $event)"
    >
      <i class="fas fa-undo mr-1"></i> Revert
    </button>
    <button kendoButton (click)="closeDetail()" [primary]="true">Close</button>
  </kendo-dialog-actions>
</kendo-dialog>

<!-- Combined Detail Modal -->
<kendo-dialog
  *ngIf="isDetailOpen && isCombineLog"
  [title]="'History Log Detail'"
  [width]="'80vw'"
  (close)="closeDetail()"
  cssClass="history-log-detail-dialog"
>
  <!-- Loading Skeleton -->
  <div
    *ngIf="isDetailLoading && !selectedLogDetail"
    class="history-log-detail-skeleton"
  >
    <div class="d-flex align-items-center mb-3 flex-wrap" style="gap: 12px">
      <div class="skeleton-shimmer badge-skeleton"></div>
      <div class="skeleton-shimmer text-skeleton" style="width: 120px"></div>
      <div class="skeleton-shimmer text-skeleton" style="width: 240px"></div>
    </div>
  </div>

  <!-- Combined Header Summary -->
  <ng-container *ngIf="selectedLogDetail">
    <div class="d-flex align-items-center mb-3 flex-wrap" style="gap: 12px">
      <span
        class="badge"
        [class.badge-danger]="filterOverride?.action === 'PAUSE'"
        [class.badge-success]="filterOverride?.action === 'UNPAUSE'"
      >
        {{ filterOverride?.action === "PAUSE" ? "PAUSED" : "UNPAUSE" }}
      </span>
      <span class="text-muted small">
        <i class="fas fa-robot mr-1"></i> Automated
      </span>
      <span class="text-muted small">
        Total: {{ combinedStats?.totalCount }} &nbsp;|&nbsp; Applied:
        {{ combinedStats?.appliedCount }} &nbsp;|&nbsp; Failed:
        {{ combinedStats?.failedCount }}
      </span>
    </div>
  </ng-container>

  <!-- Search input -->
  <div class="search-container mb-3">
    <div class="search-input-wrapper">
      <i class="feather icon-search search-icon"></i>
      <input
        type="text"
        class="form-control search-input"
        placeholder="Search by SKU, ASIN..."
        [(ngModel)]="detailSearch"
        [disabled]="isDetailLoading"
        (input)="onDetailSearchChange($event.target.value)"
      />
      <button
        *ngIf="detailSearch"
        class="clear-search-btn"
        (click)="clearSearch()"
        [disabled]="isDetailLoading"
        title="Clear search"
      >
        <i class="feather icon-x"></i>
      </button>
    </div>
  </div>

  <!-- Treelist (reuses same config) -->
  <app-forecast-rxtreelist
    [idField]="'_id'"
    [columns]="activeDetailColumns"
    [rootItems]="detailRootItems"
    [totalRootCount]="detailTotal"
    [pageSize]="detailPageSize"
    [skip]="detailSkip"
    [levelConfigs]="treeLevelConfigs"
    [height]="'40vh'"
    [loading]="isDetailLoading"
    [fullScreenIconIsVisible]="false"
    [toogleFullScreenIsVisible]="false"
    [showCheckboxColumn]="false"
    (pageChange)="onDetailPageChange($event)"
    (sortFilterChange)="onDetailSortFilterChange($event)"
  >
    <ng-template appTreelistCustomCell="inventoryStatus" let-dataItem>
      <div class="d-flex align-items-center justify-content-center">
        <ng-container [ngSwitch]="dataItem.inventoryStatus">
          <kendo-chip
            *ngSwitchCase="'OUT_OF_STOCK'"
            rounded="full"
            themeColor="error"
            icon="cancel"
            >Out of Stock</kendo-chip
          >
          <kendo-chip
            *ngSwitchCase="'HIGH_RISK'"
            rounded="full"
            themeColor="inverse"
            icon="x-circle"
            >High Risk</kendo-chip
          >
          <kendo-chip
            *ngSwitchCase="'MODERATE_RISK'"
            rounded="full"
            themeColor="warning"
            icon="minus-circle"
            >Moderate Risk</kendo-chip
          >
          <kendo-chip
            *ngSwitchCase="'WELL_STOCK'"
            rounded="full"
            themeColor="success"
            icon="check-circle"
            >Well Stock</kendo-chip
          >
          <span *ngSwitchDefault>{{ dataItem.inventoryStatus }}</span>
        </ng-container>
      </div>
    </ng-template>

    <ng-template appTreelistCustomCell="prevState" let-dataItem>
      <div class="d-flex align-items-center justify-content-center">
        <ng-container *ngIf="dataItem.prevState; else emptyPrev">
          <kendo-chip
            rounded="full"
            [themeColor]="
              dataItem.prevState === 'ENABLED' ? 'success' : 'error'
            "
          >
            {{ dataItem.prevState }}
          </kendo-chip>
        </ng-container>
        <ng-template #emptyPrev><span></span></ng-template>
      </div>
    </ng-template>

    <ng-template appTreelistCustomCell="newState" let-dataItem>
      <div class="d-flex align-items-center justify-content-center">
        <ng-container *ngIf="dataItem.newState; else emptyNew">
          <kendo-chip
            rounded="full"
            [themeColor]="dataItem.newState === 'ENABLED' ? 'success' : 'error'"
          >
            {{ dataItem.newState }}
          </kendo-chip>
        </ng-container>
        <ng-template #emptyNew><span></span></ng-template>
      </div>
    </ng-template>

    <ng-template appTreelistCustomCell="reason" let-dataItem>
      <span
        style="white-space: normal; word-break: break-word; display: block"
        >{{ dataItem.reason }}</span
      >
    </ng-template>

    <ng-template appTreelistCustomCell="updatedAt" let-dataItem>
      <span style="white-space: normal; word-break: break-word; display: block">
        {{ dataItem.updatedAt | date: "MMM dd, yyyy, hh:mm a" }}
      </span>
    </ng-template>
  </app-forecast-rxtreelist>

  <kendo-dialog-actions>
    <button
      kendoButton
      (click)="onDownloadAllSnapshots()"
      [primary]="false"
    >
      <i class="feather icon-download mr-1"></i> Download
    </button>
    <button
      kendoButton
      *ngIf="isCombineLog && selectedLogDetail && selectedLogDetail.headers[0]?.triggerType !== 'REVERT' && !isAnyReverted(selectedLogDetail.headers)"
      [primary]="false"
      (click)="onReverts(selectedLogDetail.headers, $event)"
    >
      <i class="fas fa-undo mr-1"></i> Revert
    </button>
    <button kendoButton (click)="closeDetail()" [primary]="true">Close</button>
  </kendo-dialog-actions>
</kendo-dialog>
